import React from 'react';

const ButtonHeader = ({value}) =>{
    return <button type="button" className="text-2xl text-white hover:underline px-5">{value}</button>
}

export default ButtonHeader;